module.exports = __webpack_public_path__ + "img/upmood_watch_logo-1.e0c24800.png";